import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../api";
import { Mark } from "../components/ui";

interface LoginOptions {
  bitbucket: boolean;
  devLogin: boolean;
  localLogin: boolean;
  workspace: string;
}

export function SignIn() {
  const options = useQuery({ queryKey: ["auth-config"], queryFn: () => api<LoginOptions>("/auth/config") });
  const qc = useQueryClient();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const passwordSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api("/auth/local", { method: "POST", body: JSON.stringify({ email, password }) });
      setPassword("");
      await qc.invalidateQueries({ queryKey: ["me"] });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  const devSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api(`/auth/dev?username=${encodeURIComponent(name)}`, { method: "POST" });
      await qc.invalidateQueries({ queryKey: ["me"] });
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <main className="signin">
      <div className="signin-card">
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}><Mark size={28} /><strong>SCO Lab</strong></div>
        <h1>525K Supply Chain Optimization Lab</h1>
        <p className="muted">Every 525K client project, where it runs, and the keys to it. Sign in with your Bitbucket account{options.data ? ` in the ${options.data.workspace} workspace` : ""}.</p>
        {options.data?.bitbucket && <a className="btn primary" style={{ height: 40 }} href="/api/auth/login">Sign in with Bitbucket</a>}
        {options.data?.localLogin && (
          <form style={{ display: "grid", gap: 12 }} onSubmit={passwordSignIn}>
            <label className="field"><span>Email</span><input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
            <label className="field"><span>Password</span><input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
            <button className="btn primary" style={{ height: 40 }} disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
            {error && <p className="error">{error}</p>}
          </form>
        )}
        {options.data && !options.data.bitbucket && !options.data.devLogin && !options.data.localLogin && <p className="error">Bitbucket sign-in isn't configured on this server yet.</p>}
        {options.data?.devLogin && (
          <form style={{ display: "grid", gap: 12 }} onSubmit={devSignIn}>
            <label className="field">
              <span>Development sign-in</span>
              <input className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name or email" required aria-describedby="dev-hint" />
              <span className="hint" id="dev-hint">Only on a developer's machine; the real lab uses Bitbucket.</span>
            </label>
            <button className="btn primary" style={{ height: 40 }}>Sign in</button>
            {error && <p className="error">{error}</p>}
          </form>
        )}
      </div>
    </main>
  );
}
